/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * This represents list of case categories supported by case management service. The following are the list of categories
 * with description:-
 * 1) MANIFEST: This category involves in handling manifest related issues. Few examples :-
 * a) Manifest file not found, i.e., The whole manifest file is not received by carrier
 * b) Item received without data, i.e., some packages were physically received by carrier but no shipment
 * information received in manifest
 * c) Missing articles, i.e., some packages were not physically received but there are shipment information
 * in received manifest
 *
 * 2) TRANSPORTATION_FINANCIAL_DISPUTES: This category handles cases that involves 3P carriers payment related issues.
 * It includes research and resolution for reconciliation exceptions between
 * 3P carriers and Amazon.
 *
 * 3) TRANSPORTATION_OPERATIONS: This category deals with transportation issues related to operations,
 * which are encountered by third-party carriers. For instance, a scenario where
 * the vehicle responsible for transporting packages arrives late at the Fulfillment
 * Center or Carrier Hub.
 *
 * 4) NON_PERFORMANCE_COMPENSATION: This category deals with issues  pertaining to performance-related reports
 * aligned with pre-defined Key Performance Indicators (KPIs) outlined in the
 * contract between Amazon and the Carrier.
 *
 * 5) LABEL : This category addresses problems related to labels, such as unreadable text, missing fields,
 * or labels that are cut and not scannable.
 *
 * 6) LAUNCHES : This category pertains to issues related to launches, such as a lane launch or a station launch.
 **/
export var Category;
(function (Category) {
    Category["MANIFEST"] = "MANIFEST";
    Category["TRANSPORTATION_FINANCIAL_DISPUTES"] = "TRANSPORTATION_FINANCIAL_DISPUTES";
    Category["TRANSPORTATION_OPERATIONS"] = "TRANSPORTATION_OPERATIONS";
    Category["NON_PERFORMANCE_COMPENSATION"] = "NON_PERFORMANCE_COMPENSATION";
    Category["LABEL"] = "LABEL";
    Category["LAUNCHES"] = "LAUNCHES";
})(Category || (Category = {}));
